import { ShipmentUnit } from "src/types";

export function convertMetricWeightToImperial(weightInKg: number): number {
  return parseFloat((weightInKg * 2.20462).toFixed(4));
}

export function convertMetricLengthToImperial(lengthInCm: number): number {
  return parseFloat((lengthInCm * 0.393701).toFixed(4));
}

export function convertShipmentUnitFromMetricToImperial(unit: ShipmentUnit): ShipmentUnit {
  return {
    type: unit.type,
    quantity: unit.quantity,
    weight: convertMetricWeightToImperial(unit.weight),
    length: convertMetricLengthToImperial(unit.length),
    width: convertMetricLengthToImperial(unit.width),
    height: convertMetricLengthToImperial(unit.height)
  };
}
